import _ from 'lodash';

export default function convertFunctionImplementationToCode(obj) {
  if (!_.isObjectLike(obj)) return;
  if (_.isFunction(obj.function)) {
    obj.code = extractCode(obj.function.toString());
  }
  _.forEach(obj, convertFunctionImplementationToCode);
}

const getBetween = (str, a, b) => str.substring(str.indexOf(a) + 1, str.lastIndexOf(b));

const indentCode = lines => {
  const pos = lines[0].search(/[^ ]/);
  return _.map(lines, line => line.substring(pos));
};

const extractCode = code => {
  if (/^function/.test(code) || /=> {/.test(code)) {
    let lines = getBetween(code, '{', '}').split('\n');
    lines = _.initial(_.tail(lines));
    return indentCode(lines).join('\n');
  }

  if (/=>/.test(code)) {
    const lines = code.substring(code.search(/=>/) + 3).split('\n');
    const oneLiner = indentCode(lines).join(' ');
    return ['return ' + oneLiner + ';'];
  }

  // eslint-disable-next-line no-debugger
  debugger;
  throw new Error('Not supported.');
};
